import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Button, Collapse, Paper } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useTranslation } from "react-i18next";


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  disclaimerButton: {
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontWeight: 500,
    padding: theme.spacing(1, 0),
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  icon: {
    marginLeft: theme.spacing(1),
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shorter,
    }),
  },
  contentPaper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
  },
  disclaimerContent: {
    textAlign: 'justify',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
}));

export default function SimulationDisclaimer() {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box className={classes.root}>
      <Button 
        variant="text" 
        className={classes.disclaimerButton}
        onClick={handleToggle}
        disableRipple
        aria-expanded={isOpen}
        startIcon={isOpen ? <RemoveIcon /> : <AddIcon />}
      >
        <Typography variant="body1">
          {t('disclaimer')}
        </Typography>
      </Button>
      
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Paper className={classes.contentPaper} elevation={0}>
          <Typography className={classes.disclaimerContent}>
            {t('disclaimer_info')}
          </Typography>
        </Paper>
      </Collapse>
    </Box>
  );
}